import { Checkbox, Grid, TableCell, TableHead, TableRow } from "@mui/material";
import React, { useState, useRef, useCallback } from "react";
import { icons } from "../constants";

const ResizeHandle = ({ onMouseDown }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        ...resizeHandleStyle,
        borderRight: isHovered ? '2px solid #00A7CD' : '2px solid transparent',
      }}
      onMouseDown={onMouseDown}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
};

const CommonTableHead = ({
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  tableHeadCells,
  showPosition,
  columnWidths,
  onColumnResize,
  hideCheckbox = false,
}) => {
  const [isResizing, setIsResizing] = useState(false);
  const [resizingColumn, setResizingColumn] = useState(null);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const effectiveTableHeadCells = tableHeadCells.filter(
    (headCell) => showPosition || headCell.id !== "position"
  );

  const handleMouseDown = useCallback((e, columnId) => {
    e.preventDefault();
    setIsResizing(true);
    setResizingColumn(columnId);
    startXRef.current = e.clientX;
    startWidthRef.current = columnWidths[columnId] || 200;

    const handleMouseMove = (e) => {
      const diff = e.clientX - startXRef.current;
      const newWidth = Math.max(100, startWidthRef.current + diff); // Minimum width of 100px
      onColumnResize(columnId, newWidth);
    };

    const handleMouseUp = () => {
      setIsResizing(false);
      setResizingColumn(null);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [columnWidths, onColumnResize]);

  return (
    <TableHead>
      <TableRow>
        {!hideCheckbox && (
          <TableCell padding="checkbox" style={checkboxCellStyle}>
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{
                "aria-label": "select all desserts",
              }}
            />
          </TableCell>
        )}
        {effectiveTableHeadCells.map((headCell, index) => (
          <TableCell
            key={headCell.id}
            align={"left"}
            padding={"none"}
            style={{
              ...tableCellStyle,
              width: columnWidths[headCell.id] || 100,
              minWidth: columnWidths[headCell.id] || 100,
              maxWidth: columnWidths[headCell.id] || 200,
            }}
          >
            <div style={cellContentStyle}>
              <span style={tableHeadTextStyles}>{headCell.label}</span>
              {headCell.id === "photo" ||
              headCell.id === "audio" ? undefined : (
                <img
                  src={
                    orderBy === headCell.id
                      ? order === "asc"
                        ? icons.SortSelectedIcon
                        : icons.SortSelectedDescIcon
                      : icons.TableHeadIcon
                  }
                  alt=""
                  onClick={createSortHandler(headCell.id)}
                  style={filterIconStyles}
                />
              )}
              {/* Resize handle */}
              {index < effectiveTableHeadCells.length - 1 && (
                <ResizeHandle
                  onMouseDown={(e) => handleMouseDown(e, headCell.id)}
                />
              )}
            </div>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default CommonTableHead;

const tableHeadTextStyles = {
  color: "#020303",
  fontWeight: 700,
  fontSize: 14,
  fontFamily: "Avenir Book, sans-serif",
};

const filterIconStyles = {
  width: 24,
  height: 24,
  marginLeft: "auto",
  cursor: "pointer",
};

const tableCellStyle = {
  border: "1px solid #F2F2F2",
  paddingLeft: 10,
  overflow: 'hidden',
};

const checkboxCellStyle = {
  border: "1px solid #F2F2F2",
};

const cellContentStyle = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '100%',
};

const resizeHandleStyle = {
  position: 'absolute',
  right: '-2px',
  top: 0,
  bottom: 0,
  width: '8px',
  cursor: 'col-resize',
  backgroundColor: 'transparent',
  zIndex: 10,
  borderRight: '2px solid transparent',
};
